import { render, staticRenderFns } from "./CheckCode.vue?vue&type=template&id=4c85e784&"
import script from "./CheckCode.vue?vue&type=script&lang=js&"
export * from "./CheckCode.vue?vue&type=script&lang=js&"
import style0 from "./CheckCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports